import React from "react";
import Header from "../Components/Header";
import Footer from "../Components/Footer";
import Pagetitle from "../Components/Pagetitle";

function Privacypolicies() {
  return (
    <>
      <main className="container-fluid">
        <Header />
        <Pagetitle />
        <div className="row py-5 px-sm-5">
          <div className="col">
            <h1 className="text-center fw-bold">Privacy Policy</h1>
            <p className="mt-3">
              Welcome to Color Kingdon, your destination for premium colouring books. 
              We value your trust and are committed to protecting your privacy. 
              This Privacy Policy explains how we collect, use, disclose, and safeguard 
              your personal information when you visit our website or interact with our services.
            </p>
            <ul className="list-unstyled mt-4">
              <li className="pt-3">
                <h5 className="fw-bold">1. Information We Collect</h5>
                <p>
                  We may collect the following types of information from our users and customers:
                </p>
                <ul>
                  <li>
                    <strong>Personal Information:</strong> Name, contact number, email address, 
                    shipping/billing address, and other details you provide during checkout or inquiries.
                  </li>
                  <li>
                    <strong>Payment Information:</strong> Securely processed through authorized 
                    payment gateways (we do not store full payment card details).
                  </li>
                  <li>
                    <strong>Device & Usage Data:</strong> IP address, browser type, operating system, 
                    and pages visited to help us improve our website experience.
                  </li>
                  <li>
                    <strong>Cookies:</strong> We use cookies to enhance your browsing experience, 
                    remember preferences, and track website analytics.
                  </li>
                </ul>
              </li>

              <li className="pt-3">
                <h5 className="fw-bold">2. How We Use Your Information</h5>
                <p>Your information may be used for:</p>
                <ul>
                  <li>Processing and delivering your colouring book orders.</li>
                  <li>Responding to your inquiries and customer support requests.</li>
                  <li>Improving our website, colouring books, and services.</li>
                  <li>Sending promotional offers, updates, and new colouring book releases (only if you opt-in).</li>
                  <li>Compliance with legal obligations and fraud prevention.</li>
                </ul>
              </li>

              <li className="pt-3">
                <h5 className="fw-bold">3. Information Sharing & Disclosure</h5>
                <p>
                  We respect your privacy. Color Kingdon does not sell, rent, or trade 
                  your personal information to any third parties. However, we may share 
                  limited information with:
                </p>
                <ul>
                  <li>
                    Trusted service providers such as courier partners (Shipway, DTDC), 
                    payment gateways (Razorpay), and hosting providers — only to the extent 
                    necessary for order fulfillment.
                  </li>
                  <li>Legal authorities when required by law, regulation, or government request.</li>
                </ul>
              </li>

              <li className="pt-3">
                <h5 className="fw-bold">4. Data Security</h5>
                <p>
                  We implement appropriate technical and organizational measures to protect 
                  your information against unauthorized access, alteration, disclosure, or destruction. 
                  All transactions are processed through secure servers using SSL encryption and 
                  compliant payment gateways like Razorpay.
                </p>
              </li>

              <li className="pt-3">
                <h5 className="fw-bold">5. Cookies Policy</h5>
                <p>Our website uses cookies to:</p>
                <ul>
                  <li>Understand user preferences and improve website functionality.</li>
                  <li>Monitor traffic patterns and analytics.</li>
                  <li>Enable certain site features (like cart storage and login sessions).</li>
                </ul>
                <p>
                  You can choose to disable cookies through your browser settings, 
                  though some features may not function properly.
                </p>
              </li>

              <li className="pt-3">
                <h5 className="fw-bold">6. Third-Party Links</h5>
                <p>
                  Our website may contain links to external websites. Color Kingdon is not 
                  responsible for the privacy practices or content of third-party sites. 
                  We recommend reviewing their privacy policies before sharing any personal information.
                </p>
              </li>

              <li className="pt-3">
                <h5 className="fw-bold">7. Your Rights</h5>
                <p>You have the right to:</p>
                <ul>
                  <li>Access and update your personal data.</li>
                  <li>Request deletion of your data (subject to legal retention requirements).</li>
                  <li>Opt out of promotional communications at any time.</li>
                </ul>
                <p>
                  To exercise these rights, please contact us at:
                  <br />
                  <a className="text-success text-decoration-none" href="mailto:support@colorkingdon.in">
                    📩 Email: support@colorkingdon.in
                  </a>
                </p>
              </li>

              <li className="pt-3">
                <h5 className="fw-bold">8. Policy Updates</h5>
                <p>
                  We may update this Privacy Policy periodically to reflect changes in legal, 
                  technical, or business developments. The latest version will always be available 
                  on this page with an updated "Last Updated" date.
                </p>
              </li>

              <li className="pt-3">
                <h5 className="fw-bold">9. Contact Us</h5>
                <p>
                  For any questions, feedback, or privacy concerns, please contact:
                  <br />
                  <strong>Color Kingdon</strong>
                  <br />
                  📍 Sikar, Rajasthan, India
                  <br />
                  <a className="text-success text-decoration-none" href="mailto:support@colorkingdon.in">
                    📧 support@colorkingdon.in
                  </a>
                  <br />
                  <a className="text-success text-decoration-none" href="tel:+919251952096">
                    📞 +91 9251952096
                  </a>
                  <br />
                  <a className="text-success text-decoration-none" href="http://colorkingdon.in">
                    🌐 www.colorkingdon.in
                  </a>
                </p>
              </li>
            </ul>
          </div>
        </div>
        <Footer />
      </main>
    </>
  );
}

export default Privacypolicies;